import { render, staticRenderFns } from "./ManageReason.vue?vue&type=template&id=1d54dd7a"
import script from "./ManageReason.vue?vue&type=script&lang=js"
export * from "./ManageReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports